import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useHistory } from 'react-router'
import { Helmet } from 'react-helmet'
// import { property } from 'lodash'

import { createBrowserHistory } from 'history'
import { getPageContent } from './api.js'

import { getData, search } from './api.js'
import Listing from './Listing.jsx'
import PagePagination from './PagePagination.jsx'
import { isServer } from './isServer.js'
import RentalAppraisalForm from './RentalAppraisalForm.jsx'

const Rentals = props => {
  const history = useHistory()
  const { id, name, status, propertyType } = useParams()
  const [data, setData] = useState([])
  const [dataCount, setDataCount] = useState(0)
  const [limit, setLimit] = useState(500)
  const [offset, setOffset] = useState(0)
  const [rentedData, setRentedData] = useState([])
  const [rentedDataCount, setRentedDataCount] = useState(0)
  const [rentedOffset, setRentedOffset] = useState(0)
  const [metaDesc, setMetaDesc] = useState('')

  const initialIsMobile = !isServer ? window.innerWidth <= 800 : false
  const [isMobile, setIsMobile] = useState(initialIsMobile)
  const [rentedLimit, setRentedLimit] = useState(initialIsMobile ? 4 : 12)

  const [rentalContent, setRentalsContent] = useState('')

  useEffect(() => {
    getRentalsContent()
  }, [])

  const getRentalsContent = () => {
    getPageContent('rentals', (data) => setRentalsContent(data[0].value))
  }

  const handleResize = () => {
    if (!isServer) {
      if (window.innerWidth <= 800) {
        setIsMobile(true)
        setRentedLimit(4)
        setRentedOffset(0)
      } else {
        setIsMobile(false)
        setRentedLimit(12)
        setRentedOffset(0)
      }
    }
  }

  useEffect(() => {
    if (!isServer) {
      window.addEventListener('resize', handleResize)
    }

    let desc = 'Looking to rent property? Houses, Apartments and Townhouses for rent in Auckland & Waiheke Island.'
              handleGetData("live", limit, offset)
              handleGetData("rented,leased", rentedLimit, rentedOffset)

        setMetaDesc(desc)
  }, [offset, limit, rentedLimit, rentedOffset, props.searchQuery, propertyType])

  function handleGetData(type, limit, offset) {
    let url = `rental_properties?limit=${limit}&offset=${offset}&status=${type}`
    
    if (type === 'rented,leased') {
      url += `&order_by=updated_at&sort=desc`
      getData(url, handleSetDataRented)
    } else {
      url += `&order_by=listed_date&sort=desc`
      getData(url, handleSetData)
    }
  }


  const handleSetData = (data, count) => {
    setDataCount(count)
    setData(data)
  }

  const handleSetDataRented = (data, count) => {
    setRentedDataCount(count)
    setRentedData(data)
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
  let headerTitle = "Properties For Rent"

  return (
    <div className="main-body">
        <Helmet>
          <meta charSet="utf-8" />
          <meta property="og:title" 
          content={`${capitalizeFirstLetter(headerTitle)} | 'Kellands Real Estate'}`}
          />
          <title>
          {`${capitalizeFirstLetter(headerTitle)} 
          | 'Kellands Real Estate'}`}
          </title>
          <meta name="description" content={`${metaDesc}`} />
          <meta property="og:description" content={`${metaDesc}`} />
        </Helmet>
      <div className="column">
        {data.length ?
        <h1 className="main-page-header">
          {headerTitle}
        </h1> : <div></div>}
       <div />
        <div className="listings-container">
          {data.length ? data.map((property, idx) => {
            return (
              // Use standard link for property view page
              // This page is loaded on the server
              <a href={`/property/view/${property.url}`}
              className={`listing-container ${isMobile && 'listing-container-mobile'}`}
              key={property.id}>
                <Listing property={property} idx={idx} />
              </a>
            )
          })
            : <div />}
        </div>
      </div>
      {dataCount > 4 ?
        <PagePagination
          itemsPerPage={limit}
          limit={limit}
          setLimit={(rpp) => setLimit(rpp)}
          offset={offset}
          setOffset={(startIdx) => setOffset(startIdx)}
          count={dataCount}
        />
        : <div />
      }
            <div className="column">
              {rentedData.length ?
        <h1 className="main-page-header">
          Rented
        </h1> : <div></div> }
       <div />
        <div className="listings-container">
          {rentedData.length ? rentedData.map((property, idx) => {
            return (
              // Use standard link for property view page
              // This page is loaded on the server
              <a href={`/property/view/${property.url}`}
              className={`listing-container ${isMobile && 'listing-container-mobile'}`}
              key={property.id}>
                <Listing property={property} idx={idx} />
              </a>
            )
          })
            : <div />}
        </div>
      </div>
      {rentedDataCount > 4 ?
        <PagePagination
          itemsPerPage={rentedLimit}
          limit={rentedLimit}
          setLimit={(rpp) => setRentedLimit(rpp)}
          offset={rentedOffset}
          setOffset={(startIdx) => setRentedOffset(startIdx)}
          count={rentedDataCount}
        />
        : <div />
      }
        <RentalAppraisalForm /> 
       <div className="rentals-text-row">
           <div className="rentals-sub">
            <h1>Property Management</h1>
            <div className="rentals-p-container">
                <p className="rentals-multi-line rentals-p">You're not just another number, get the attention you deserve.</p>
                <p className="rentals-one-line rentals-p">You're not just another number, get the attention you deserve.</p>
            </div>
        </div>
        <div className="rentals-text">
           <div className="rentals-text-inner">
          <p className="about-text"
            dangerouslySetInnerHTML={{ __html: rentalContent }}>
          </p>
        </div>
        </div>
      </div>
    </div >
  )

}

export default Rentals